// extracted by mini-css-extract-plugin
export var pillWrapper = "_xw-0";
export var showOverflow = "_xw-1";